import styled from "styled-components";
import { Card } from "react-bootstrap";

export const StrategyCardContainer = styled(Card)`
  background-color: ${({ theme }) => theme.card.bg.strategies};
  border-radius: 10px;
  padding: 15px;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.card.border.primary};

  &:hover {
    border: 1px solid ${({ theme }) => theme.card.hover.primary};
  }

  .strategy-card-header {
    .top-header {
      margin-bottom: 12px;

      img {
        height: 47px;
        width: 47px;
      }

      .strategy-type {
        background: ${({ theme }) => theme.button.bg.secondary};
        color: ${({ theme }) => theme.button.font.secondary};
        border-radius: 28px;
        padding: 6px 16px;
        font-weight: 500;
        font-size: 13px;
        text-transform: capitalize;
      }
    }

    .name-header {
      margin-bottom: 20px;
      align-items: center;

      .strategy-name {
        font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_500};
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_18};
        color: ${({ theme }) => theme.global.text.tertiary};
        margin-bottom: 0;
      }

      .author-name {
        font-size: 13px;
        font-weight: 400;
        color: ${({ theme }) => theme.card.color.senary};
      }
    }
  }

  .description {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-height: 1.5em;
    max-height: 4.5em;
    height: 4.5em;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.image.color.quaternary};
    p {
      font-size: 13px;
      font-weight: 400;
      margin: 0;
    }
  }

  .return-wrapper {
    margin-bottom: 21px;

    .total {
      font-size: 14px;
      font-weight: 400;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
    }

    .percentage {
      border-radius: 26px;
      width: 85px;
      height: 27px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;

      &.gain {
        background-color: ${({ theme }) => theme.global.bg.profit};
        color: ${({ theme }) => theme.constants.COLOR_GREEN};
      }

      &.loss {
        background-color: ${({ theme }) => theme.global.bg.loss};
        color: ${({ theme }) => theme.constants.COLOR_RED};
      }
    }
  }

  .badge {
    font-weight: 600;
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_19};
  }

  @media (max-width: 768px) {
    .recharts-surface {
      margin-top: 0;
    }
  }
`;
